import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebTempTermoExtratoDesligamento } from '../models/WebTempTermoExtratoDesligamento.model';
import { environment } from 'environments/environment';
import { WebTempTermoExtratoContribAutopatrocinio } from '../models/WebTempTermoExtratoContribAutopatrocinio.model';
import { WebTempTermoExtratoBPD } from '../models/WebTempTermoExtratoBPD.model';
import { HttpClient } from '@angular/common/http';
import { WebTempTermoRequerimentoAposentadoria } from '../models/WebTempTermoRequerimentoAposentadoria,model';

@Injectable({
  providedIn: 'root'
})
export class WebTempTermoRequerimentoAposentadoriaService {
  private strAction = 'api/WebTempTermoRequerimentoAposentadoria';

  constructor(private http: HttpClient) {

  }
//http://localhost:40320/api/WebTempTermoRequerimentoAposentadoria/GetById/3
  public getById(idTermo: number): Observable<WebTempTermoRequerimentoAposentadoria> {
    return this.http.get<WebTempTermoRequerimentoAposentadoria>(`${environment.TrustCRMApiHost}api/WebTempTermoRequerimentoAposentadoria/GetById/${idTermo}`);
  }
}


